<template>
  <div class="layout">
    <header-bar  @menuToggle="menuToggle" @searchToggle="searchToggle"></header-bar>
    <div class="navwrap"></div>
    <menu-bar v-show="menuBarToggle"></menu-bar>
    <search-bar v-show="searchBarToggle" @searchToggle="searchToggle"></search-bar>
    <div class="med-wrapper-box">
      <div>
        <div class="m-content-wrapper">
          <router-view></router-view>
        </div>
      </div>
    </div>

    <footer-bar></footer-bar>
  </div>
</template>
<script>
import footerBar from "./FooterBar.vue";
import headerBar from "./HeaderBar.vue";
import menuBar from "./MenuBar.vue";
import searchBar from "./SearchBar.vue";

export default {
  name: "mainFrame",
  components: {
    footerBar,
    headerBar,
    menuBar,
    searchBar
  },
  data() {
    return {
        menuBarToggle:false,
        searchBarToggle:false,
        logined:false,
    };
  },
  created() {
    /* let userToken = localStorage.getItem("current_user_token");
            if (userToken === undefined || userToken === null) {
                localStorage.clear();
                window.location.href='/system_login';
            }*/
  },
  mounted() {},
  props: {},
  methods: {
    me: function(name) {
      this.nav.state = name;
    },
    ml: function() {
      this.nav.state = "";
    },
    subme: function(name) {
      this.nav.substate = name;
    },
    subml: function() {
      this.nav.substate = "";
    },
    toUrl: function(url) {
      if (url) {
        location.href = url;
      }
    },
    LogOut: function() {
      localStorage.clear();
      this.logined = false;
      location.href = "/login";
    },
    goSearch: function() {
      location.href = "/search/search_result";
    },
    menuToggle: function(val) {
      this.menuBarToggle = val;
    },
    searchToggle: function(val) {
      this.searchBarToggle = val;
      if(!val){
          this.menuBarToggle = val;
      }      
    },
  }
};
</script>

<style scoped>
.med-wrapper-box{
    min-height: 400px;
}
</style>